import Database from './Database';
import DatabaseContext, { DatabaseConsumer, DatabaseProvider } from './DatabaseContext';

export { DatabaseContext, DatabaseConsumer, DatabaseProvider };

export default Database;
